import { NgModule } from '@angular/core';
import { ComissoesComponent } from './comissoes.component';
import { HistoricoComponent } from './historico/historico.component';
import { ReceberComponent } from './receber/receber.component';
import { InvestidoresComponent } from './investidores/investidores.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [
    ComissoesComponent,
    ReceberComponent,
    HistoricoComponent,
    InvestidoresComponent
  ],
  imports: [
    SharedModule
  ],
  exports: []
})
export class ComissoesModule{}